import { AnyAction, Reducer } from 'redux';

export const STORE_RXORDERDATA = 'data/rx-order-data';
export const STORE_DESIGNTYPE_RXFORM = 'data/rx-designtype-data';
export const STORE_NOTATIONS_RXFORM = 'data/rx-notations-data';
export const STORE_PRODUCT_RXFORM = 'data/rx-product-data';
export const STORE_PRODUCTNAME_RXFORM = 'data/rx-productname-data';
export const STORE_MODEL_RXFORM = 'data/rx-model-data';
export const STORE_GETMESSAGES = 'data/rx-getmessage-data';

export const STORE_ROWNO_RXFORM_MESSAGE = 'data/rowno-message-data';
export const STORE_MESSAGEID_RXFORM_MESSAGE = 'data/messageid-data';
export const STORE_MFROM_RXFORM_MESSAGE = 'data/mfrom-data';
export const STORE_MDATE_RXFORM_MESSAGE = 'data/mdate-data';
export const STORE_MESSAGE_RXFORM_MESSAGE = 'data/message-data';
export const STORE_ATTACHEMENT_RXFORM_MESSAGE = 'data/attachement-data';
export const STORE_ATTACHFILENAME_RXFORM_MESSAGE = 'data/attachementname-data';
export const STORE_CREATEDON_RXFORM_MESSAGE = 'data/createdon-data';
export const STORE_MESSAGEATTACHMENT_RXFORM_MESSAGE = 'data/messageattachment-data';
export const STORE_FILES_MSGATTACHMENT = 'data/file-attachement';
export const STORE_FILES_GETATTACHMENT = 'data/file-getattachement';
export const STORE_GETDATAFILES = 'data/getdatafiles-stl';
export const STORE_SIGNEDURL_STL = 'signed-url/stl-selected';

export interface GetFileData {
    rowno: string;
    filetype: string;
    filename: string;
    oci_status: string;
    createdon: string;
}

export interface GetAllFileData {
    rowno: string;
    filetype: string;
    filename: string;
    caseno: string;
}

export interface AttachementData {
    // status: string;
    // message: string;
    // data: string;
    attachmentname: string;
    attachfilename: string;
}

export interface UserRxFormData {
    rowno: string;
    ds_rxdetailid: string;
    ds_ordersid: string;
    designtype: string;
    notations: string;
    product: string;
    productname: string;
    materialname: string;
    model: string;
}

export interface MsgAttachments {
    attachfilename: string;
    oci_status: string;
}

export interface GetUserMessage {
    rowno: string;
    messageid: string;
    mfrom: string;
    mdate: string;
    message: string;
    attachmentname: string;
    attachfilename: string;
    createdon: string;
    messageattachmentsrow: string;
    oci_status: string;
    attachments: MsgAttachments[];
}

export interface UserRxFormState {
    userRxdata: UserRxFormData[];
    getUserMessage: GetUserMessage[];
    getAttachementData: AttachementData[];
    getFileData: GetFileData[];
    signedUrlStl: Array<string>;
    designtype: string;
    notations: string;
    product: string;
    productname: string;
    model: string;
    rowno: string;
    messageid: string;
    mfrom: string;
    mdate: string;
    message: string;
    attachmentname: string;
    attachfilename: string;
    createdon: string;
    messageattachmentsrow: string;
    messageFiles: Array<File>;
}

const initialState: UserRxFormState = {
    userRxdata: [],
    designtype: '',
    notations: '',
    product: '',
    productname: '',
    model: '',
    getUserMessage: [],
    rowno: '',
    messageid: '',
    mfrom: '',
    mdate: '',
    message: '',
    attachmentname: '',
    attachfilename: '',
    createdon: '',
    messageattachmentsrow: '',
    messageFiles: [],
    getAttachementData: [],
    getFileData: [],
    signedUrlStl: []
};

const reducer: Reducer<UserRxFormState> = (state: UserRxFormState = initialState, action: AnyAction): UserRxFormState => {
    switch (action.type) {
        case STORE_RXORDERDATA:
            return {
                ...state,
                userRxdata: action.userRxdata
            };
        case STORE_DESIGNTYPE_RXFORM:
            return {
                ...state,
                designtype: action.designtype
            };
        case STORE_NOTATIONS_RXFORM:
            return {
                ...state,
                notations: action.notations
            };
        case STORE_PRODUCT_RXFORM:
            return {
                ...state,
                product: action.product
            };
        case STORE_PRODUCTNAME_RXFORM:
            return {
                ...state,
                productname: action.productname
            };
        case STORE_MODEL_RXFORM:
            return {
                ...state,
                model: action.model
            };
        case STORE_GETMESSAGES:
            return {
                ...state,
                getUserMessage: action.getUserMessage
            };
        case STORE_ROWNO_RXFORM_MESSAGE:
            return {
                ...state,
                rowno: action.rowno
            };
        case STORE_MESSAGEID_RXFORM_MESSAGE:
            return {
                ...state,
                messageid: action.messageid
            };
        case STORE_MFROM_RXFORM_MESSAGE:
            return {
                ...state,
                mfrom: action.mfrom
            };
        case STORE_MDATE_RXFORM_MESSAGE:
            return {
                ...state,
                mdate: action.mdate
            };
        case STORE_MESSAGE_RXFORM_MESSAGE:
            return {
                ...state,
                message: action.message
            };
        case STORE_ATTACHEMENT_RXFORM_MESSAGE:
            return {
                ...state,
                attachmentname: action.attachmentname
            };
        case STORE_ATTACHFILENAME_RXFORM_MESSAGE:
            return {
                ...state,
                attachfilename: action.attachfilename
            };
        case STORE_CREATEDON_RXFORM_MESSAGE:
            return {
                ...state,
                createdon: action.createdon
            };
        case STORE_MESSAGEATTACHMENT_RXFORM_MESSAGE:
            return {
                ...state,
                messageattachmentsrow: action.messageattachmentsrow
            };
        case STORE_FILES_MSGATTACHMENT:
            return {
                ...state,
                messageFiles: action.messageFiles
            };
        case STORE_FILES_GETATTACHMENT:
            return {
                ...state,
                getAttachementData: action.getAttachementData
            };
        case STORE_GETDATAFILES:
            return {
                ...state,
                getFileData: action.getFileData
            };
        case STORE_SIGNEDURL_STL:
            return {
                ...state,
                signedUrlStl: action.signedUrlStl
            };
            default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/rxForm.tsx